module.exports = __webpack_public_path__ + "static/media/buy_start_service_rent_3.51ac41e3.jpg";